import React, { useEffect, useState } from 'react';
import styles from './enrichment-save-to-button.module.sass';
import cx from 'classnames';
import { Button } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { Menu, Cascader } from 'antd';
import mixpanel from 'mixpanel-browser';
import EnrichmentExistingFeedCollectionSaveModal from '../EnrichmentExistingFeedCollectionSaveModal';
import EnrichmentNewFeedCollectionSaveModal from '../EnrichmentNewFeedCollectionSaveModal';
import { STATUS } from '../../../../redux/constants';
import { incrementUIRequestsCounter } from '../../../../redux/utils/websocket/incrementUIRequestsCounter';

function EnrichmentSaveToButton({ props, type, mergeAPIEnrichmentData }) {
  const [
    isEnrichCollectionSaveModalVisible,
    setIsEnrichCollectionSaveModalVisible,
  ] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isNewFeedModalVisible, setIsNewFeedModalVisible] = useState(false);
  const [
    isNewCollectionModalVisible,
    setIsNewCollectionModalVisible,
  ] = useState(false);
  const [selectedFeed, setSelectedFeed] = useState('');
  const [selectedCollection, setSelectedCollection] = useState('');
  const [nameOfNewFeed, setNameOfNewFeed] = useState('');
  const [vendorOfNewFeed, setVendorOfNewFeed] = useState(null);
  const [customScoreOfNewFeed, setCustomScoreOfNewFeed] = useState(0);
  const [nameOfNewCollection, setNameOfNewCollection] = useState('');
  const [vendorOfNewCollection, setVendorOfNewCollection] = useState(null);
  const [customScoreOfCollection, setCustomScoreOfCollection] = useState(0);

  useEffect(() => {
    const newFeed = props?.newlyCreatedSource;
    if (
      newFeed?.name !== nameOfNewFeed &&
      newFeed?.name !== nameOfNewCollection
    ) {
      return () => {};
    }
    const iocToAdd = {
      ...mergeAPIEnrichmentData,
      feed_uuid: newFeed?.uuid,
    };
    props.addIOCJson(iocToAdd);
    if (['domain', 'url', 'ip', 'ipv4']?.indexOf(type) > -1) {
      mixpanel.track('Saved to Feed', {
        location: 'enrich',
        'ioc name': selectedFeed?.name,
        'ioc uuid': selectedFeed?.uuid,
      });
    } else {
      mixpanel.track('Saved to Feed', {
        location: 'explore results',
        'ioc name': selectedFeed?.name,
        'ioc uuid': selectedFeed?.uuid,
      });
    }
    setIsNewFeedModalVisible(false);
  }, [props?.newlyCreatedSource]);

  const handleSaveToNewFeed = ({
    containerState,
    containerName,
    iocType,
    customScore,
    containerVendor,
    setModalVisibility,
  }) => {
    let data = {
      state: containerState, // FEED or COLLECTION,
      name: containerName,
      threat_type: iocType,
      custom_score: customScore,
    };
    if (containerVendor) {
      data = {
        ...data,
        vendor: containerVendor,
      };
    }
    const res = props.createEmptySource(data);
    setModalVisibility(false);
  };

  const handleOk = (selectedFeedUUID) => {
    const iocAddToFeedDataObject = {
      ...mergeAPIEnrichmentData,
      feed_uuid: selectedFeedUUID,
    };

    props.addIOCJson(iocAddToFeedDataObject);

    if (['domain', 'url', 'ip', 'ipv4']?.indexOf(type) > -1) {
      mixpanel.track('Saved to Feed', {
        location: 'enrich',
        'ioc name': selectedFeed?.name,
        'ioc uuid': selectedFeed?.uuid,
      });
    } else {
      mixpanel.track('Saved to Feed', {
        location: 'explore results',
        'ioc name': selectedFeed?.name,
        'ioc uuid': selectedFeed?.uuid,
      });
    }
    incrementUIRequestsCounter();
  };

  const handleOkCollection = (selectedCollectionUUID) => {
    const iocAddToCollectionDataObject = {
      ...mergeAPIEnrichmentData,
      feed_uuid: selectedCollectionUUID,
    };
    props.addIOCJson(iocAddToCollectionDataObject);
    if (['domain', 'url', 'ip', 'ipv4']?.indexOf(type) > -1) {
      mixpanel.track('Saved to Collection', {
        location: 'enrich',
        'ioc name': selectedCollection?.name,
        'ioc uuid': selectedCollection?.uuid,
      });
    } else {
      mixpanel.track('Saved to Collection', {
        location: 'explore results',
        'ioc name': selectedCollection?.name,
        'ioc uuid': selectedCollection?.uuid,
      });
    }
    setIsEnrichCollectionSaveModalVisible(false);
    incrementUIRequestsCounter();
  };

  const saveToDropdownOptions = [
    {
      value: 'collection',
      label: 'Collection',
      children: [
        {
          value: 'new_collection',
          label: 'New',
        },
        {
          value: 'existing_collection',
          label: 'Existing Collection',
        },
      ],
    },
    {
      value: 'feed',
      label: 'Feed',
      children: [
        {
          value: 'new_feed',
          label: 'New',
        },
        {
          value: 'existing_feed',
          label: 'Existing Feed',
        },
      ],
    },
  ];

  const enrichSaveDropdownMenu = (
    <Menu>
      <Menu.Item
        aria-label="colMenu"
        key="1"
        onClick={() => setIsEnrichCollectionSaveModalVisible(true)}
      >
        Collection
      </Menu.Item>
      <Menu.Item
        aria-label="feedMenu"
        key="2"
        onClick={() => setIsModalVisible(true)}
      >
        Feed
      </Menu.Item>
    </Menu>
  );

  const handleSaveToFeedOrCollection = (data) => {
    const [_, action] = data;
    if (action === 'existing_feed') {
      setIsModalVisible(true);
      mixpanel.track('Save to Feed Attempt', {
        location: 'enrich',
        'ioc name': props?.mergeAPIEnrichment?.ioc_name,
        'ioc uuid': props?.mergeAPIEnrichment?.ioc_uuid,
      });
    } else if (action === 'existing_collection') {
      setIsEnrichCollectionSaveModalVisible(true);
      mixpanel.track('Save to Collection Attempt', {
        location: 'enrich',
        'ioc name': props?.mergeAPIEnrichment?.ioc_name,
        'ioc uuid': props?.mergeAPIEnrichment?.ioc_uuid,
      });
    } else if (action === 'new_feed') {
      setIsNewFeedModalVisible(true);
      mixpanel.track('Save to Feed Attempt', {
        location: 'enrich',
        'ioc name': props?.mergeAPIEnrichment?.ioc_name,
        'ioc uuid': props?.mergeAPIEnrichment?.ioc_uuid,
      });
    } else if (action === 'new_collection') {
      setIsNewCollectionModalVisible(true);
      mixpanel.track('Save to Collection Attempt', {
        location: 'enrich',
        'ioc name': props?.mergeAPIEnrichment?.ioc_name,
        'ioc uuid': props?.mergeAPIEnrichment?.ioc_uuid,
      });
    }
  };

  return (
    <>
      <Cascader
        onChange={handleSaveToFeedOrCollection}
        options={saveToDropdownOptions}
        overlay={enrichSaveDropdownMenu}
        disabled={
          !(
            props?.mySubscriptionPlanStatus === STATUS.LOADED &&
            props?.mySubscriptionPlan?.has_access_to_sources
          )
        }
      >
        <Button
          className={cx(styles.enrichmentSaveToButton, {
            [styles.disabled]: !(
              props?.mySubscriptionPlanStatus === STATUS.LOADED &&
              props?.mySubscriptionPlan?.has_access_to_sources
            ),
          })}
          icon={<DownOutlined />}
        >
          Save to
        </Button>
      </Cascader>

      {isModalVisible && (
        <EnrichmentExistingFeedCollectionSaveModal
          typeOfContainer={'feed'}
          iocType={type === 'ipv4' ? 'ip' : type}
          setIsEnrichSaveFeedCollectionModalVisible={setIsModalVisible}
          isEnrichSaveFeedCollectionModalVisible={isModalVisible}
          handleSave={handleOk}
          props={props}
        />
      )}

      {isEnrichCollectionSaveModalVisible && (
        <EnrichmentExistingFeedCollectionSaveModal
          typeOfContainer={'collection'}
          iocType={type === 'ipv4' ? 'ip' : type}
          setIsEnrichSaveFeedCollectionModalVisible={
            setIsEnrichCollectionSaveModalVisible
          }
          isEnrichSaveFeedCollectionModalVisible={
            isEnrichCollectionSaveModalVisible
          }
          handleSave={handleOkCollection}
          props={props}
        />
      )}

      {isNewFeedModalVisible && (
        <EnrichmentNewFeedCollectionSaveModal
          nameOfNewFeedCollection={nameOfNewFeed}
          vendorOfNewFeedCollection={vendorOfNewFeed}
          setIsNewFeedCollectionModalVisible={setIsNewFeedModalVisible}
          isNewFeedCollectionModalVisible={isNewFeedModalVisible}
          handleSave={() =>
            handleSaveToNewFeed({
              containerState: 'FEED',
              containerName: nameOfNewFeed,
              iocType: type === 'ipv4' ? 'ip' : type,
              customScore: customScoreOfNewFeed,
              containerVendor: vendorOfNewFeed,
              setModalVisibility: setIsNewFeedModalVisible,
            })
          }
          setCustomScoreOfNewFeedCollection={setCustomScoreOfNewFeed}
          setNameOfNewFeedCollection={setNameOfNewFeed}
          setVendorOfNewFeedCollection={setVendorOfNewFeed}
          typeOfContainer={'feed'}
          iocType={type === 'ipv4' ? 'ip' : type}
        />
      )}
      {isNewCollectionModalVisible && (
        <EnrichmentNewFeedCollectionSaveModal
          nameOfNewFeedCollection={nameOfNewCollection}
          vendorOfNewFeedCollection={vendorOfNewCollection}
          setIsNewFeedCollectionModalVisible={setIsNewCollectionModalVisible}
          isNewFeedCollectionModalVisible={isNewCollectionModalVisible}
          handleSave={() =>
            handleSaveToNewFeed({
              containerState: 'COLLECTION',
              containerName: nameOfNewCollection,
              iocType: type === 'ipv4' ? 'ip' : type,
              customScore: customScoreOfCollection,
              containerVendor: vendorOfNewCollection,
              setModalVisibility: setIsNewCollectionModalVisible,
            })
          }
          setCustomScoreOfNewFeedCollection={setCustomScoreOfCollection}
          setNameOfNewFeedCollection={setNameOfNewCollection}
          setVendorOfNewFeedCollection={setVendorOfNewCollection}
          typeOfContainer={'collection'}
          iocType={type === 'ipv4' ? 'ip' : type}
        />
      )}
    </>
  );
}

export default EnrichmentSaveToButton;
